import { CoreInitiativesTasksName } from './name';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getInitiativeTasks } from '@api';
import { updateInitiativeReferences } from '../_idMap/actions';
import { updateSonarObjectReferences } from '../../sonar-objects/_idMap/actions';
import { TaskItem, UpdateSonarObjectReferenceRequest } from '@types';

export const coreInitiativesTasksGetAsyncSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request, response) =>
				updateInitiativeReferences([
					{
						initiativeId: request.initiativeId,
						tasks: response.map(({ initiativeSonarObjects, ...rest }) => ({
							...rest,
							sonarObjects: initiativeSonarObjects.map((object) => ({
								itemId: object.id,
								sonarObjectId: object.sonarObjectId
							})) as Array<TaskItem>
						}))
					}
				])
		],
		successDataActionCreators: [
			(response) =>
				updateSonarObjectReferences(
					response.reduce(
						(previous, current) => [
							...previous,
							...current.initiativeSonarObjects.map(
								(taskObject) =>
									({
										displayName: taskObject.displayName,
										isDeleted: taskObject.isVanished,
										parentDisplayName: taskObject.parentDisplayName,
										parentSonarObjectId: taskObject.parentSonarObjectId,
										relatedCounts: taskObject.relatedCounts,
										sonarObjectId: taskObject.sonarObjectId,
										sonarObjectType: taskObject.sonarObjectType,
										statusId: taskObject.sonarObjectStatusId,
										tags: taskObject.tagIds,
										versionNumber: taskObject.versionNumber
									} as UpdateSonarObjectReferenceRequest)
							)
						],
						[] as Array<UpdateSonarObjectReferenceRequest>
					)
				)
		]
	},
	name: CoreInitiativesTasksName,
	receive: true,
	request: true,
	requestHandler: getInitiativeTasks
});
